module.exports = __webpack_public_path__ + "static/img/Dmitry.f07f1ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dmitry.jpg
// module id = lrC1
// module chunks = 0